import angular from "angular";
import {BroadcastService} from "@common/service/broadcast.service";
import {ICustomScope} from "@common/crSelector/directives/paginated-subj-list/paginated-subj-list.directive"

export interface IEcvPaginatedMemberList {
    init();
}

export class EcvPaginatedMemberList implements IEcvPaginatedMemberList {
    static $inject = ["$q", "$scope", "$timeout", "BroadcastService"];

    item;
    selectedItem;
    selectedMember;
    searchText = '';
    loadedData = [];
    selectedChange: any;
    onLoadMore: any;
    placeholder = '';
    listType = '';
    dataLoading = false;
    searchQuery: any = "";
    enableError = false;
    isRequired = true;
    fieldDisabled: boolean;
    hideLabel: boolean;
    memDetails;
    tempItem: any;
    hideClearBtn: boolean;
    isFocused: boolean;

    constructor(
        private $q : angular.IQService,
        $scope: ng.IScope,
        private $timeout: ng.ITimeoutService,
        BroadcastService : BroadcastService
    ) {
        let memberListVm: any = this;
        BroadcastService.registerCallBack('create.subject.member.list.error', $scope.$id, (itemId) => {
            (itemId === memberListVm.item) && (memberListVm.enableError = true);
        });

        BroadcastService.registerCallBack('reset-selected-member', $scope.$id, () => {
            memberListVm.selectedItem = null;
            memberListVm.selectedMember = null;
            memberListVm.tempItem = null;
            memberListVm.searchText = null;
        });

        BroadcastService.registerCallBack('resetSearchText', $scope.$id, () => {
            memberListVm.searchText = null;
        });
        $scope.$on('$destroy', function () {
            BroadcastService.removeCallBack('create.subject.member.list.error', $scope.$id);
            BroadcastService.removeCallBack('reset-selected-member', $scope.$id);
            BroadcastService.removeCallBack('resetSearchText', $scope.$id);
        })
    }

    init = (initial = true) => {
        this.selectedItem = this.selectedMember;
        if (!this.dataLoading) {
            if (!this.loadedData) {
                this.loadedData = [];
            } else {
                this.loadedData.splice(0, this.loadedData.length);
            }
            this.loadMore(0);
        }
        if (!!initial) {
            this.$timeout(() => {
                let rep = angular.element(document.getElementsByClassName("md-virtual-repeat-scroller"));
                rep.on('scroll', (evt) => {
                    const index = rep.length - 1;
                    if (rep[index].scrollHeight - rep[index].clientHeight - rep[index].scrollTop < 5 && !this.dataLoading) {
                        let scrollPos = rep[index].scrollTop;
                        let len = this.loadedData.length;
                        let pgSz = Math.ceil(len / 10);
                        this.loadMore(pgSz).then(() => {
                            rep[index].scrollTop = scrollPos;
                        });
                    }
                });
            }, 10);
        }
    }

    loadMore = (pgSz, srchQryChange?) => {
        this.dataLoading = true;
        let deferred = this.$q.defer();
        let el = angular.element("#paginated-member-drpdwn input");
        el.length > 0 && ((el.scope() as any).$mdAutocompleteCtrl.loading = true);
        this.onLoadMore({page: pgSz, size: 10, searchText: this.searchText}).then((data) => {
            if (!!srchQryChange) {
                this.loadedData.splice(0, this.loadedData.length);
            }
            data.forEach(element => {
                this.loadedData.push(element);
            });
            let el = angular.element("#paginated-member-drpdwn input");
            if (el.length > 0 || data.length === 0) {
                (el.scope() as any).$mdAutocompleteCtrl.loading = false;
            }
            this.dataLoading = false;
            deferred.resolve();
        });
        return deferred.promise;
    }

    selectedItemChange = (item) => {
        if (!!item) {
            this.tempItem = item;
            angular.element(".member-cr-height md-autocomplete input").blur();
            this.inputBlurred();
            this.$timeout(() => {
                this.selectedChange({member: item});
            }, 0);
        } else {
            return;
        }
    }

    searchTextChange = (text) => {
        if (this.searchQuery != text) {
            this.searchQuery = text
            !!this.searchQuery && (this.searchQuery = text.trim().toLowerCase());
            this.loadMore(0, true);
        }
    }

    getClasses = () => {
        let classes = [];
        if (this.enableError && !this.selectedItem) {
            classes.push('error-bottom-line')
        }
        return classes;
    }

    inputClicked = (ev?) => {
        if (!!this.hideClearBtn && !this.isFocused && !(this.fieldDisabled || !!ev.currentTarget.attributes.disabled)) {
            this.isFocused = true;
            if (!!this.selectedItem) {
                this.tempItem = this.selectedItem;
                this.searchText = '';
            }
        }
    }

    inputBlurred = () => {
        if (!!this.hideClearBtn && !!this.isFocused) {
            this.isFocused = false;
            if (!!this.tempItem) {
                this.setPreviousItem(this.tempItem);
            }
        }
    }

    setPreviousItem = (team) => {
        this.selectedItem = team;
        !!team && (this.searchText = team.fullName);
        this.tempItem = undefined;
    }

    openDropdown = () => {
        let el = angular.element(".member-cr-height md-autocomplete input");
        el.select().focus();
        this.inputClicked();
    }
}

function ecvPaginatedMemberList(): ng.IDirective {
    return {
        restrict: 'E',
        templateUrl: 'app/common/userSelector/paginated-member.directive.html',
        replace: true,
        scope: true,
        controller: EcvPaginatedMemberList,
        controllerAs: 'memberListVm',
        bindToController: {
            'selectedChange': '&',
            'onLoadMore': '&',

            'placeholder': '@placeholder',
            'listType': '@listType',
            'selectedMember': '<',
            'item': '=',
            "isRequired": '=?',
            'fieldDisabled': '=?disable',
            'hideLabel': '=?',
            'memDetails': '=?',
            'hideClearBtn': '=?',
            'emailDetails': '=?'
        },
        link: (scope: ICustomScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: IEcvPaginatedMemberList): void => {
            controller.init();
            scope.$on("$destroy", function () {
                scope.element = null;
            });
            scope.element = element;
        }
    }
}

angular.module('eCareVault.common.userSelector').directive('ecvPaginatedMemberList', ecvPaginatedMemberList);

